import { createPortal, memo } from 'preact/compat'

// @font-face rules doesn't work within Shadow DOM
// see https://github.com/mdn/interactive-examples/issues/887
// and https://bugs.chromium.org/p/chromium/issues/detail?id=336876
function extractFontLinks(source: string): { css: string; links: string[] } {
  const fontImportRegex = /@import\s+url\(['"](:?.*fonts\.googleapis\.com.*)['"]\);/gi
  const links: string[] = []
  const css = source.replace(fontImportRegex, (_, url) => {
    links.push(url)
    return ''
  })

  return { css, links }
}

const FontLinks = ({ links }: { links: string[] }) => {
  return (
    <>
      {links.map((href, idx) => (
        <link rel="stylesheet" href={href} key={idx} />
      ))}
    </>
  )
}

export interface UserStyleProps {
  css: string
}

export const UserStyle = memo(function UserStyle({ css }: UserStyleProps) {
  const { css: outputCss, links } = extractFontLinks(css)

  return (
    <>
      {links.length > 0 && createPortal(<FontLinks links={links} />, document.head)}
      {links.length > 0 && <FontLinks links={links} />}

      <style>{outputCss}</style>
    </>
  )
})
